export interface ResponseData<T> {
  Resault_Value: T;
  Has_Error: boolean;
  Error_Message: string;
  Total: number;
}

export interface ResponesModel<T> {
  Resault_Value: T;
  Has_Error: boolean;
  Error_Message: string;
}

export class ResponseObject {
  Success: boolean;
  Data: object;
  Errors: string[];
  Succeeded: boolean;
  Message: string;
}
